import React, { useContext } from "react";
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "@xyflow/react";
import { EdgeClickContext } from "./EdgeClickContext";

export default function WarningEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const onEdgeClick = useContext(EdgeClickContext);
  const notes = data?.notes || [];
  const tooltip = notes.map((n) => (typeof n === "string" ? n : n.message)).join("\n");

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{ stroke: "var(--color-error)", strokeDasharray: "5 3", strokeWidth: 2 }}
      />
      <EdgeLabelRenderer>
        <div
          className="warning-edge-label"
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: "all",
            cursor: "pointer",
          }}
          onClick={() => onEdgeClick?.(id)}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" aria-label="Compatibility warning">
            <title>{tooltip}</title>
            <polygon points="8,1 15,14 1,14" fill="var(--color-error)" stroke="#fff" strokeWidth="1" />
            <text x="8" y="12" textAnchor="middle" fill="#fff" fontSize="9" fontWeight="bold">!</text>
          </svg>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
